export default __webpack_public_path__ + "static/media/squared_minus.d91a2670.svg";